import { render, staticRenderFns } from "./add-category-modal.vue?vue&type=template&id=1e7f7fe1&scoped=true&"
import script from "./add-category-modal.vue?vue&type=script&lang=js&"
export * from "./add-category-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7f7fe1",
  null
  
)

export default component.exports